import Joi from "joi";
import FormValidationResult from "../../../../../common/utils/validation/types/form-validation-result";
import formValidationService from "../../../../../common/utils/validation/form-validation.service";

const validateMaximumHaltingTime = (
  maximumHaltingTime: number | null,
): FormValidationResult => {
  const validationSchema = Joi.number().min(0).max(240);
  return formValidationService.validate(maximumHaltingTime, validationSchema);
};

const orderOptimizerRailyListingMaximumHaltingTimeModalValidationService = {
  validateMaximumHaltingTime,
};

export default orderOptimizerRailyListingMaximumHaltingTimeModalValidationService;
